// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Container,
//   Typography,
//   TextField,
//   InputAdornment,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   CircularProgress,
//   TablePagination,
//   Grid,
//   Rating,
//   Chip,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   IconButton,
//   Tooltip,
//   Select,
//   MenuItem,
//   FormControl,
//   Snackbar,
//   Alert,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import { format } from "date-fns";
// import { useDispatch, useSelector } from "react-redux";
// import createInstance from "../../../api/axiosinstance";

// const HRTable = () => {
//   const { isAuthenticated, user } = useSelector((state) => state.auth);
//   const [candidates, setCandidates] = useState([]);
//   const [filteredCandidates, setFilteredCandidates] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [updatingDecision, setUpdatingDecision] = useState({});
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });
//   const [confirmDialog, setConfirmDialog] = useState({
//     open: false,
//     roundId: null,
//     decision: "",
//   });

//   const organizationId = user?.organizationId;
//   const aiDisha = createInstance("DISHA");

//   // Fetch all candidates feedback
//   useEffect(() => {
//     const fetchCandidates = async () => {
//       try {
//         setLoading(true);
//         const response = await aiDisha.get(
//           `/fetch_all_candidates_feedback?organization_id=${organizationId}`
//         );
//         const data = response.data;
//         setCandidates(data);
//         setFilteredCandidates(data);
//         console.log("candidates", data);
//       } catch (error) {
//         console.error("Error fetching candidates:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCandidates();
//   }, [organizationId]);

//   // Handle search functionality
//   useEffect(() => {
//     if (searchTerm.trim() === "") {
//       setFilteredCandidates(candidates);
//     } else {
//       const lowercasedSearch = searchTerm.toLowerCase();
//       const filtered = candidates.filter(
//         (candidate) =>
//           candidate.candidate_name.toLowerCase().includes(lowercasedSearch) ||
//           candidate.candidate_id.toLowerCase().includes(lowercasedSearch) ||
//           candidate.job_title.toLowerCase().includes(lowercasedSearch) ||
//           candidate.interviewer_name.toLowerCase().includes(lowercasedSearch)
//       );
//       setFilteredCandidates(filtered);
//     }
//     setPage(0); // Reset to first page when searching
//   }, [searchTerm, candidates]);

//   // Handle HR Decision Change
//   const handleHRDecisionChange = async (roundId, decision) => {
//     try {
//       setUpdatingDecision({ ...updatingDecision, [roundId]: true });

//       const response = await aiDisha.patch(
//         `/Hr_decision?round_id=${roundId}&decision=${decision}`
//       );

//       if (response.status === 200) {
//         // Update the local state to reflect the change
//         const updatedCandidates = candidates.map((candidate) => {
//           if (candidate.round_id === roundId) {
//             return { ...candidate, hr_decision: decision };
//           }
//           return candidate;
//         });

//         setCandidates(updatedCandidates);
//         setFilteredCandidates(
//           updatedCandidates.filter((candidate) => {
//             if (searchTerm.trim() === "") return true;
//             const lowercasedSearch = searchTerm.toLowerCase();
//             return (
//               candidate.candidate_name
//                 .toLowerCase()
//                 .includes(lowercasedSearch) ||
//               candidate.candidate_id.toLowerCase().includes(lowercasedSearch) ||
//               candidate.job_title.toLowerCase().includes(lowercasedSearch) ||
//               candidate.interviewer_name
//                 .toLowerCase()
//                 .includes(lowercasedSearch)
//             );
//           })
//         );

//         setSnackbar({
//           open: true,
//           message: "HR Decision updated successfully!",
//           severity: "success",
//         });
//       }
//     } catch (error) {
//       console.error("Error updating HR decision:", error);
//       setSnackbar({
//         open: true,
//         message: "Failed to update HR decision. Please try again.",
//         severity: "error",
//       });
//     } finally {
//       setUpdatingDecision({ ...updatingDecision, [roundId]: false });
//     }
//   };

//   // Handle snackbar close
//   const handleSnackbarClose = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }
//     setSnackbar({ ...snackbar, open: false });
//   };

//   // Fetch specific candidate feedback
//   const fetchCandidateFeedback = async (candidateId) => {
//     try {
//       const response = await fetch(
//         `http://194.195.114.60:8000/get_candidates_feedback?candidate_id=${candidateId}&organization_id=${organizationId}`
//       );
//       if (!response.ok) {
//         throw new Error("Failed to fetch candidate feedback");
//       }
//       const data = await response.json();
//       return data;
//     } catch (error) {
//       console.error(
//         `Error fetching feedback for candidate ${candidateId}:`,
//         error
//       );
//       return [];
//     }
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleSearchChange = (event) => {
//     setSearchTerm(event.target.value);
//   };

//   // Function to format date nicely
//   const formatDate = (dateString) => {
//     if (!dateString) return "—";

//     try {
//       const date = new Date(dateString);

//       if (isNaN(date.getTime())) return "Invalid date";

//       return date.toLocaleString("en-GB", {
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//         hour: "2-digit",
//         minute: "2-digit",
//         hour12: false, // ✅ 24-hour format
//       });
//     } catch {
//       return "Invalid date";
//     }
//   };

//   // Get appropriate color for decision chip
//   const getDecisionColor = (decision) => {
//     switch (decision) {
//       case "Strong Hire":
//         return "success";
//       case "Hire":
//         return "primary";
//       case "No Hire":
//         return "error";
//       default:
//         return "default";
//     }
//   };

//   // Get appropriate color for HR decision chip
//   const getHRDecisionColor = (decision) => {
//     switch (decision) {
//       case "Hire":
//         return "success";
//       case "No Hire":
//         return "error";
//       case "Next Round":
//         return "warning";
//       default:
//         return "default";
//     }
//   };

//   // Calculate average rating for a candidate
//   const calculateAverageRating = (candidate) => {
//     return candidate.total_score / 5; // Divide total score by number of categories (5)
//   };

//   return (
//     <Container maxWidth="xl">
//       <Box sx={{ my: 4 }}>
//         <Typography variant="h4" component="h1" gutterBottom>
//           Candidate Interview Feedback
//         </Typography>

//         <Box sx={{ mb: 3 }}>
//           <TextField
//             fullWidth
//             variant="outlined"
//             placeholder="Search by candidate name, ID, job title, or interviewer..."
//             value={searchTerm}
//             onChange={handleSearchChange}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <SearchIcon />
//                 </InputAdornment>
//               ),
//             }}
//             sx={{
//               "& .MuiInputBase-input::placeholder": {
//                 color: "#033538", // Change this to your desired color
//                 opacity: 1, // Override the default opacity
//               },
//             }}
//           />
//         </Box>

//         {loading ? (
//           <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
//             <CircularProgress />
//           </Box>
//         ) : filteredCandidates.length === 0 ? (
//           <Paper sx={{ p: 3, textAlign: "center" }}>
//             <Typography>
//               No candidates found matching your search criteria.
//             </Typography>
//           </Paper>
//         ) : (
//           <>
//             <TableContainer
//               component={Paper}
//               sx={{ backgroundColor: "#033538", color: "white" }}
//             >
//               <Table sx={{ minWidth: 750 }}>
//                 <TableHead>
//                   <TableRow>
//                     <TableCell sx={{ color: "white" }}>Candidate</TableCell>
//                     <TableCell sx={{ color: "white" }}>Job Title</TableCell>
//                     <TableCell sx={{ color: "white" }}>
//                       Interview Round
//                     </TableCell>
//                     <TableCell sx={{ color: "white" }}>Interviewer</TableCell>
//                     <TableCell sx={{ color: "white" }} align="center">
//                       Date & Time
//                     </TableCell>
//                     <TableCell sx={{ color: "white" }} align="center">
//                       Overall Rating
//                     </TableCell>
//                     <TableCell sx={{ color: "white" }} align="center">
//                       Decision
//                     </TableCell>
//                     <TableCell sx={{ color: "white" }} align="center">
//                       HR Decision
//                     </TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {filteredCandidates
//                     .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                     .map((candidate) => (
//                       <React.Fragment key={candidate._id}>
//                         <TableRow hover>
//                           <TableCell sx={{ color: "white" }}>
//                             <Typography variant="subtitle2">
//                               {candidate.candidate_name}
//                             </Typography>
//                             <Typography variant="caption" color="white">
//                               {candidate.candidate_id}
//                             </Typography>
//                           </TableCell>
//                           <TableCell sx={{ color: "white" }}>
//                             {candidate.job_title}
//                           </TableCell>
//                           <TableCell sx={{ color: "white" }}>
//                             {candidate.round}
//                           </TableCell>
//                           <TableCell sx={{ color: "white" }}>
//                             {candidate.interviewer_name}
//                           </TableCell>
//                           <TableCell sx={{ color: "white" }} align="center">
//                             {formatDate(candidate.date_and_time)}
//                           </TableCell>
//                           <TableCell align="center">
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                               }}
//                             >
//                               <Rating
//                                 value={calculateAverageRating(candidate)}
//                                 precision={0.5}
//                                 readOnly
//                                 size="small"
//                               />
//                               <Typography variant="body2" sx={{ ml: 1 }}>
//                                 ({candidate.total_score}/25)
//                               </Typography>
//                             </Box>
//                           </TableCell>
//                           <TableCell align="center">
//                             <Chip
//                               label={candidate.decision}
//                               color={getDecisionColor(candidate.decision)}
//                               size="small"
//                             />
//                           </TableCell>
//                           <TableCell align="center">
//                             <FormControl size="small" sx={{ minWidth: 120 }}>
//                               <Select
//                                 value={candidate.Hr_decision || ""}
//                                 onChange={(e) =>
//                                   setConfirmDialog({
//                                     open: true,
//                                     roundId: candidate.round_id,
//                                     decision: e.target.value,
//                                   })
//                                 }
//                                 displayEmpty
//                                 disabled={updatingDecision[candidate.round_id]}
//                                 sx={{
//                                   color: "white",
//                                   "& .MuiOutlinedInput-notchedOutline": {
//                                     borderColor: "red",
//                                   },
//                                   "&:hover .MuiOutlinedInput-notchedOutline": {
//                                     borderColor: "white",
//                                   },
//                                   "&.Mui-focused .MuiOutlinedInput-notchedOutline":
//                                     {
//                                       borderColor: "white",
//                                     },
//                                   "& .MuiSelect-icon": {
//                                     color: "white",
//                                   },
//                                   "& .MuiMenuItem-root": {
//                                     color: "red", // Set text color to black
//                                   },
//                                 }}
//                               >
//                                 <MenuItem
//                                   value=""
//                                   sx={{ color: "blue", opacity: "80%" }}
//                                 >
//                                   Select Decision
//                                 </MenuItem>
//                                 <MenuItem sx={{ color: "black" }} value="Hire">
//                                   Hire
//                                 </MenuItem>
//                                 <MenuItem
//                                   sx={{ color: "black" }}
//                                   value="No Hire"
//                                 >
//                                   No Hire
//                                 </MenuItem>
//                                 <MenuItem
//                                   sx={{ color: "black" }}
//                                   value="Next Round"
//                                 >
//                                   Next Round
//                                 </MenuItem>
//                               </Select>
//                             </FormControl>
//                             {candidate.hr_decision && (
//                               <Box sx={{ mt: 1 }}>
//                                 <Chip
//                                   label={candidate.hr_decision}
//                                   color={getHRDecisionColor(
//                                     candidate.hr_decision
//                                   )}
//                                   size="small"
//                                 />
//                               </Box>
//                             )}
//                             {updatingDecision[candidate.round_id] && (
//                               <Box sx={{ mt: 1 }}>
//                                 <CircularProgress size={16} />
//                               </Box>
//                             )}
//                           </TableCell>
//                         </TableRow>
//                         <TableRow sx={{ backgroundColor: "#006A71" }}>
//                           <TableCell
//                             colSpan={8}
//                             sx={{ py: 0, borderBottom: "none" }}
//                           >
//                             <Accordion sx={{ backgroundColor: "#006A71" }}>
//                               <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                                 <Typography variant="subtitle2">
//                                   Detailed Feedback
//                                 </Typography>
//                               </AccordionSummary>
//                               <AccordionDetails>
//                                 <Grid container spacing={3}>
//                                   <Grid item xs={12} md={6}>
//                                     <Typography
//                                       variant="subtitle2"
//                                       gutterBottom
//                                     >
//                                       Technical Knowledge
//                                     </Typography>
//                                     <Box
//                                       sx={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         mb: 1,
//                                       }}
//                                     >
//                                       <Rating
//                                         value={
//                                           candidate.Technical_knowledge[0]
//                                             .rating
//                                         }
//                                         readOnly
//                                         size="small"
//                                       />
//                                       <Typography
//                                         variant="body2"
//                                         sx={{ ml: 1 }}
//                                       >
//                                         (
//                                         {
//                                           candidate.Technical_knowledge[0]
//                                             .rating
//                                         }
//                                         /5)
//                                       </Typography>
//                                     </Box>
//                                     <Typography variant="body2">
//                                       {candidate.Technical_knowledge_detail}
//                                     </Typography>
//                                   </Grid>
//                                   <Grid item xs={12} md={6}>
//                                     <Typography
//                                       variant="subtitle2"
//                                       gutterBottom
//                                     >
//                                       Hands-on Skills
//                                     </Typography>
//                                     <Box
//                                       sx={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         mb: 1,
//                                       }}
//                                     >
//                                       <Rating
//                                         value={
//                                           candidate.Hands_on_skills[0].rating
//                                         }
//                                         readOnly
//                                         size="small"
//                                       />
//                                       <Typography
//                                         variant="body2"
//                                         sx={{ ml: 1 }}
//                                       >
//                                         ({candidate.Hands_on_skills[0].rating}
//                                         /5)
//                                       </Typography>
//                                     </Box>
//                                     <Typography variant="body2">
//                                       {candidate.Hands_on_skills_detail}
//                                     </Typography>
//                                   </Grid>
//                                   <Grid item xs={12} md={6}>
//                                     <Typography
//                                       variant="subtitle2"
//                                       gutterBottom
//                                     >
//                                       Problem Solving
//                                     </Typography>
//                                     <Box
//                                       sx={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         mb: 1,
//                                       }}
//                                     >
//                                       <Rating
//                                         value={
//                                           candidate.Problem_solving[0].rating
//                                         }
//                                         readOnly
//                                         size="small"
//                                       />
//                                       <Typography
//                                         variant="body2"
//                                         sx={{ ml: 1 }}
//                                       >
//                                         ({candidate.Problem_solving[0].rating}
//                                         /5)
//                                       </Typography>
//                                     </Box>
//                                     <Typography variant="body2">
//                                       {candidate.Problem_solving_detail}
//                                     </Typography>
//                                   </Grid>
//                                   <Grid item xs={12} md={6}>
//                                     <Typography
//                                       variant="subtitle2"
//                                       gutterBottom
//                                     >
//                                       Communication Skills
//                                     </Typography>
//                                     <Box
//                                       sx={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         mb: 1,
//                                       }}
//                                     >
//                                       <Rating
//                                         value={
//                                           candidate.Communication_skills[0]
//                                             .rating
//                                         }
//                                         readOnly
//                                         size="small"
//                                       />
//                                       <Typography
//                                         variant="body2"
//                                         sx={{ ml: 1 }}
//                                       >
//                                         (
//                                         {
//                                           candidate.Communication_skills[0]
//                                             .rating
//                                         }
//                                         /5)
//                                       </Typography>
//                                     </Box>
//                                     <Typography variant="body2">
//                                       {candidate.Communication_skills_detail}
//                                     </Typography>
//                                   </Grid>
//                                   <Grid item xs={12} md={6}>
//                                     <Typography
//                                       variant="subtitle2"
//                                       gutterBottom
//                                     >
//                                       Culture Fit
//                                     </Typography>
//                                     <Box
//                                       sx={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         mb: 1,
//                                       }}
//                                     >
//                                       <Rating
//                                         value={candidate.Culture_fit[0].rating}
//                                         readOnly
//                                         size="small"
//                                       />
//                                       <Typography
//                                         variant="body2"
//                                         sx={{ ml: 1 }}
//                                       >
//                                         ({candidate.Culture_fit[0].rating}/5)
//                                       </Typography>
//                                     </Box>
//                                     <Typography variant="body2">
//                                       {candidate.Culture_fit_detail}
//                                     </Typography>
//                                   </Grid>
//                                   <Grid item xs={12}>
//                                     <Box
//                                       sx={{
//                                         mt: 2,
//                                         p: 2,
//                                         bgcolor: "#f5f5f5",
//                                         borderRadius: 1,
//                                         color: "black",
//                                       }}
//                                     >
//                                       <Typography
//                                         variant="subtitle2"
//                                         gutterBottom
//                                       >
//                                         Additional Comments
//                                       </Typography>
//                                       <Typography
//                                         variant="body2"
//                                         gutterBottom
//                                         sx={{ color: "black" }}
//                                       >
//                                         Next Round Recommendation:
//                                         {candidate.next_round_recommendation}
//                                       </Typography>
//                                       <Typography
//                                         variant="body2"
//                                         sx={{ color: "black" }}
//                                       >
//                                         Remarks:
//                                         {candidate.remarks}
//                                       </Typography>
//                                     </Box>
//                                   </Grid>
//                                 </Grid>
//                               </AccordionDetails>
//                             </Accordion>
//                           </TableCell>
//                         </TableRow>
//                       </React.Fragment>
//                     ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//             <TablePagination
//               rowsPerPageOptions={[5, 10, 25]}
//               component="div"
//               count={filteredCandidates.length}
//               rowsPerPage={rowsPerPage}
//               page={page}
//               onPageChange={handleChangePage}
//               onRowsPerPageChange={handleChangeRowsPerPage}
//               sx={{
//                 color: "#033538",
//                 "& .MuiTablePagination-toolbar": {
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "flex-end", // Aligns content to the right
//                   "& .MuiTablePagination-spacer": {
//                     flex: "none", // Reduces spacer impact
//                   },
//                 },
//                 "& .MuiTablePagination-selectLabel": {
//                   color: "#033538",
//                   margin: "0 10px 0 0", // Adjust spacing
//                 },
//                 "& .MuiTablePagination-select": {
//                   color: "#033538",
//                   marginRight: "10px", // Adds space after dropdown
//                 },
//                 "& .MuiTablePagination-displayedRows": {
//                   color: "#033538",
//                   margin: "0 20px", // Centering the page info text
//                 },
//                 "& .MuiTablePagination-actions": {
//                   color: "#033538",
//                   marginLeft: "10px", // Space before navigation buttons
//                 },
//               }}
//             />
//           </>
//         )}
//       </Box>

//       {/* Snackbar for notifications */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//       >
//         <Alert
//           onClose={handleSnackbarClose}
//           severity={snackbar.severity}
//           sx={{ width: "100%" }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//       <Dialog
//         open={confirmDialog.open}
//         onClose={() =>
//           setConfirmDialog({ open: false, roundId: null, decision: "" })
//         }
//       >
//         <DialogTitle sx={{ fontWeight: "bold" }}>
//           Confirm HR Decision
//         </DialogTitle>

//         <DialogContent>
//           <Typography sx={{color:"black"}}>
//             Are you sure you want to proceed with this decision?👇
//           </Typography>
//           <Typography sx={{ mt: 1, fontWeight: 500 ,color:"black"}}>
//             <strong style={{color:"blue"}}>{confirmDialog.decision}</strong>
//           </Typography>
//           <Typography sx={{ mt: 1, color: "error.main" }}>
//             An email will be sent to the candidate.
//           </Typography>
//         </DialogContent>

//         <DialogActions>
//           <Button
//             onClick={() =>
//               setConfirmDialog({ open: false, roundId: null, decision: "" })
//             }
//             color="inherit"
//             sx={{color:"grey"}}
//           >
//             Cancel
//           </Button>

//           <Button
//             variant="contained"
//             color="primary"
//             onClick={() => {
//               handleHRDecisionChange(
//                 confirmDialog.roundId,
//                 confirmDialog.decision
//               );
//               setConfirmDialog({ open: false, roundId: null, decision: "" });
//             }}
//           >
//             Confirm & Send
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Container>
//   );
// };

// export default HRTable;








































import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  TablePagination,
  Grid,
  Rating,
  Chip,
  IconButton,
  Tooltip,
  Select,
  MenuItem,
  FormControl,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Collapse,
  Stack,
  Divider,
} from "@mui/material";
import {
  Search as SearchIcon,
  Close as CloseIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  FeedbackOutlined as FeedbackIcon,
} from "@mui/icons-material";
// import COLORS from "../../Themes/Colours";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";
import { useDispatch, useSelector } from "react-redux";
import createInstance from "../../../api/axiosinstance";

const HRTable = () => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const [candidates, setCandidates] = useState([]);
  const [filteredCandidates, setFilteredCandidates] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [updatingDecision, setUpdatingDecision] = useState({});
  const [expandedRows, setExpandedRows] = useState({});
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    roundId: null,
    decision: "",
    candidateName: "",
  });

  const organizationId = user?.organizationId;
  const aiDisha = createInstance("DISHA");
  const { COLORS } = useThemeMode();
  

  // Fetch all candidates feedback
  useEffect(() => {
    const fetchCandidates = async () => {
      try {
        setLoading(true);
        const response = await aiDisha.get(
          `/fetch_all_candidates_feedback?organization_id=${organizationId}`
        );
        const data = response.data;
        setCandidates(data);
        setFilteredCandidates(data);
        console.log("candidates", data);
      } catch (error) {
        console.error("Error fetching candidates:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCandidates();
  }, [organizationId]);

  // Handle search functionality
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredCandidates(candidates);
    } else {
      const lowercasedSearch = searchTerm.toLowerCase();
      const filtered = candidates.filter(
        (candidate) =>
          candidate.candidate_name.toLowerCase().includes(lowercasedSearch) ||
          candidate.candidate_id.toLowerCase().includes(lowercasedSearch) ||
          candidate.job_title.toLowerCase().includes(lowercasedSearch) ||
          candidate.interviewer_name.toLowerCase().includes(lowercasedSearch)
      );
      setFilteredCandidates(filtered);
    }
    setPage(0);
  }, [searchTerm, candidates]);

  // Handle row expansion
  const toggleRowExpansion = (rowId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  // Handle HR Decision Change
  const handleHRDecisionChange = async (roundId, decision) => {
    try {
      setUpdatingDecision({ ...updatingDecision, [roundId]: true });

      const response = await aiDisha.patch(
        `/Hr_decision?round_id=${roundId}&decision=${decision}`
      );

      if (response.status === 200) {
        const updatedCandidates = candidates.map((candidate) => {
          if (candidate.round_id === roundId) {
            return { ...candidate, hr_decision: decision };
          }
          return candidate;
        });

        setCandidates(updatedCandidates);
        setFilteredCandidates(
          updatedCandidates.filter((candidate) => {
            if (searchTerm.trim() === "") return true;
            const lowercasedSearch = searchTerm.toLowerCase();
            return (
              candidate.candidate_name
                .toLowerCase()
                .includes(lowercasedSearch) ||
              candidate.candidate_id.toLowerCase().includes(lowercasedSearch) ||
              candidate.job_title.toLowerCase().includes(lowercasedSearch) ||
              candidate.interviewer_name
                .toLowerCase()
                .includes(lowercasedSearch)
            );
          })
        );

        setSnackbar({
          open: true,
          message: "Interviewer Decision updated successfully!",
          severity: "success",
        });
      }
    } catch (error) {
      console.error("Error updating Interviewer Decision:", error);
      setSnackbar({
        open: true,
        message: "Failed to update Interviewer Decision. Please try again.",
        severity: "error",
      });
    } finally {
      setUpdatingDecision({ ...updatingDecision, [roundId]: false });
    }
  };

  // Handle snackbar close
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // Format date nicely
  const formatDate = (dateString) => {
    if (!dateString) return "—";

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "Invalid date";

      return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
    } catch {
      return "Invalid date";
    }
  };

  // Get decision color
  const getDecisionColor = (decision) => {
    switch (decision) {
      case "Strong Hire":
        return "#10b981";
      case "Hire":
        return "#3b82f6";
      case "No Hire":
        return "#ef4444";
      default:
        return "#6b7280";
    }
  };

  const getDecisionBgColor = (decision) => {
    switch (decision) {
      case "Strong Hire":
        return "#d1fae5";
      case "Hire":
        return "#dbeafe";
      case "No Hire":
        return "#fee2e2";
      default:
        return "#f3f4f6";
    }
  };

  // Get Interviewer Decision color
  const getHRDecisionColor = (decision) => {
    switch (decision) {
      case "Hire":
        return "#10b981";
      case "No Hire":
        return "#ef4444";
      case "Next Round":
        return "#f59e0b";
      default:
        return "#6b7280";
    }
  };

  const getHRDecisionBgColor = (decision) => {
    switch (decision) {
      case "Hire":
        return "#d1fae5";
      case "No Hire":
        return "#fee2e2";
      case "Next Round":
        return "#fef3c7";
      default:
        return "#f3f4f6";
    }
  };

  // Calculate average rating
  const calculateAverageRating = (candidate) => {
    return candidate.total_score / 5;
  };

  const tableHeaders = [
    { key: "expand", label: "" },
    { key: "candidate", label: "Candidate" },
    { key: "job", label: "Job Title" },
    { key: "round", label: "Round" },
    { key: "interviewer", label: "Interviewer" },
    { key: "date", label: "Date & Time" },
    { key: "rating", label: "Rating" },
    { key: "decision", label: "Decision" },
    { key: "Interviewer_decision", label: "Interviewer Decision" },
  ];

  return (
    <Box sx={{ background: COLORS.background, minHeight: "100vh", pb: 4 }}>
      {/* Header Section */}
      <Box sx={{ mb: 3 }}>
        <Typography
          sx={{
            fontSize: "28px",
            fontWeight: 700,
            color: COLORS.text,
            mb: 2,
          }}
        >
          Candidate Interview Feedback
        </Typography>

        {/* Search Bar */}
        <Paper
          sx={{
            p: "8px 16px",
            display: "flex",
            alignItems: "center",
            width: "100%",
            maxWidth: "500px",
            borderRadius: "8px",
            border: `1px solid ${COLORS.border}`,
            background: COLORS.primary,
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          }}
        >
          <SearchIcon sx={{ color: COLORS.textSecondary, mr: 1 }} />
          <TextField
            sx={{
              ml: 1,
              flex: 1,
              fontSize: "14px",
              "& .MuiInputBase-input": {
                padding: "0",
                fontSize: "14px",
              },
              "& .MuiInputBase-input::placeholder": {
                color: COLORS.textSecondary,
                opacity: 0.8,
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "& input::placeholder": {
                             color: `${COLORS.text} !important`, // 👈 placeholder color
                             opacity: 10, // important (MUI reduces opacity by default)
                           },
            }}
            placeholder="Search by name, ID, job, or interviewer..."
            value={searchTerm}
            onChange={handleSearchChange}
            variant="outlined"
          />
          {searchTerm && (
            <IconButton
              size="small"
              onClick={() => setSearchTerm("")}
              sx={{ color: COLORS.textSecondary }}
            >
              <CloseIcon sx={{ fontSize: "18px" }} />
            </IconButton>
          )}
        </Paper>
      </Box>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
          <CircularProgress sx={{ color: COLORS.accent }} />
        </Box>
      ) : filteredCandidates.length === 0 ? (
        <Paper
          sx={{
            p: 4,
            textAlign: "center",
            background: "white",
            border: `1px solid ${COLORS.border}`,
            borderRadius: "10px",
          }}
        >
          <Typography sx={{ color: COLORS.textSecondary }}>
            {searchTerm
              ? "No candidates found matching your search criteria."
              : "No candidate feedback available."}
          </Typography>
        </Paper>
      ) : (
        <>
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: "10px",
              border: `1px solid ${COLORS.border}`,
              overflow: "hidden",
              boxShadow: "0 4px 6px rgba(0,0,0,0.07)",
            }}
          >
            <Table size="small">
              <TableHead>
                <TableRow sx={{ background: COLORS.primary }}>
                  {tableHeaders.map((header) => (
                    <TableCell
                      key={header.key}
                      sx={{
                        color: COLORS.text,
                        fontWeight: 600,
                        fontSize: "13px",
                        // textAlign: header.key === "expand" ? "center" : "left",
                        textAlign: "center",
                        padding: "16px 12px",
                        borderBottom: `1px solid ${COLORS.border}`,
                        width: header.key === "expand" ? "50px" : "auto",
                      }}
                    >
                      {header.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredCandidates
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((candidate, index) => (
                    <React.Fragment key={candidate._id}>
                      {/* Main Row */}
                      <TableRow
                        sx={{
                          // background: index % 2 === 0 ? "white" : COLORS.background,
                          background: COLORS.background,
                          "&:hover": {
                            // background: "rgba(0, 0, 0, 0.84)",
                            background: COLORS.hoverBg,
                          },
                          borderBottom: expandedRows[candidate._id]
                            ? "none"
                            : `1px solid ${COLORS.border}`,
                        }}
                      >
                        {/* Expand Button */}
                        <TableCell
                          sx={{
                            textAlign: "center",
                            padding: "12px",
                          }}
                        >
                          <Tooltip title="View details">
                            <IconButton
                              size="small"
                              onClick={() => toggleRowExpansion(candidate._id)}
                              sx={{
                                color: COLORS.accent,
                                "&:hover": {
                                  background: "rgba(233,69,96,0.1)",
                                },
                              }}
                            >
                              {expandedRows[candidate._id] ? (
                                <ExpandLessIcon sx={{ fontSize: "20px" }} />
                              ) : (
                                <ExpandMoreIcon sx={{ fontSize: "20px" }} />
                              )}
                            </IconButton>
                          </Tooltip>
                        </TableCell>

                        {/* Candidate Name & ID */}
                        <TableCell sx={{ padding: "12px 12px", fontSize: "13px" }}>
                          <Typography sx={{ fontSize: "14px", fontWeight: 600, color: COLORS.text }}>
                            {candidate.candidate_name}
                          </Typography>
                          <Typography sx={{ fontSize: "12px", color: COLORS.textSecondary, mt: 0.5 }}>
                            {candidate.candidate_id}
                          </Typography>
                        </TableCell>

                        {/* Job Title */}
                        <TableCell sx={{ padding: "12px 12px", fontSize: "13px", color: COLORS.text }}>
                          {candidate.job_title}
                        </TableCell>

                        {/* Round */}
                        <TableCell sx={{ padding: "12px 12px", fontSize: "13px" }}>
                          <Chip
                            label={candidate.round || "N/A"}
                            size="small"
                            sx={{
                              background: COLORS.accent,
                              color: "white",
                              fontWeight: 500,
                            }}
                          />
                        </TableCell>

                        {/* Interviewer */}
                        <TableCell sx={{ padding: "12px 12px", fontSize: "13px", color: COLORS.text }}>
                          {candidate.interviewer_name}
                        </TableCell>

                        {/* Date & Time */}
                        <TableCell sx={{ padding: "12px 12px", fontSize: "12px", color: COLORS.text }}>
                          {formatDate(candidate.date_and_time)}
                        </TableCell>

                        {/* Rating */}
                        <TableCell sx={{ padding: "12px 12px", textAlign: "center" }}>
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                            <Rating
                              value={calculateAverageRating(candidate)}
                              precision={0.5}
                              readOnly
                              size="small"
                            />
                            <Typography sx={{ fontSize: "12px", color: COLORS.textSecondary }}>
                              {candidate.total_score}/25
                            </Typography>
                          </Box>
                        </TableCell>

                        {/* Decision */}
                        <TableCell sx={{ padding: "12px 12px", textAlign: "center" }}>
                          <Chip
                            label={candidate.decision}
                            size="small"
                            sx={{
                              background: getDecisionBgColor(candidate.decision),
                              color: getDecisionColor(candidate.decision),
                              fontWeight: 600,
                              fontSize: "11px",
                            }}
                          />
                        </TableCell>

                        {/* HR Decision */}
                        <TableCell sx={{ padding: "12px 12px", textAlign: "center" }}>
                          <Stack spacing={1} sx={{ alignItems: "center" }}>
                            <FormControl size="small" sx={{ minWidth: 120 }}>
                              <Select
                                value={candidate.hr_decision || ""}
                                onChange={(e) =>
                                  setConfirmDialog({
                                    open: true,
                                    roundId: candidate.round_id,
                                    decision: e.target.value,
                                    candidateName: candidate.candidate_name,
                                  })
                                }
                                displayEmpty
                                disabled={updatingDecision[candidate.round_id]}
                                sx={{
                                  fontSize: "12px",
                                  background: "white",
                                  border: `1px solid ${COLORS.border}`,
                                  borderRadius: "6px",
                                  "& .MuiSelect-icon": {
                                    color: COLORS.text,
                                  },
                                  "&:hover": {
                                    borderColor: COLORS.accent,
                                  },
                                }}
                              >
                                <MenuItem value="" sx={{ fontSize: "12px" }}>
                                  Select Decision
                                </MenuItem>
                                <MenuItem value="Hire" sx={{ fontSize: "12px" }}>
                                  Hire
                                </MenuItem>
                                <MenuItem value="No Hire" sx={{ fontSize: "12px" }}>
                                  No Hire
                                </MenuItem>
                                <MenuItem value="Next Round" sx={{ fontSize: "12px" }}>
                                  Next Round
                                </MenuItem>
                              </Select>
                            </FormControl>
                            {candidate.hr_decision && (
                              <Chip
                                label={candidate.hr_decision}
                                size="small"
                                sx={{
                                  background: getHRDecisionBgColor(candidate.hr_decision),
                                  color: getHRDecisionColor(candidate.hr_decision),
                                  fontWeight: 600,
                                  fontSize: "11px",
                                }}
                              />
                            )}
                            {updatingDecision[candidate.round_id] && (
                              <CircularProgress size={16} sx={{ color: COLORS.accent }} />
                            )}
                          </Stack>
                        </TableCell>
                      </TableRow>

                      {/* Expandable Details Row */}
                      <TableRow
                        sx={{
                          background: expandedRows[candidate._id]
                            ? COLORS.background
                            : "transparent",
                          borderBottom: expandedRows[candidate._id]
                            ? `1px solid ${COLORS.border}`
                            : "none",
                        }}
                      >
                        <TableCell colSpan={tableHeaders.length} sx={{ padding: 0}}>
                          <Collapse
                            in={expandedRows[candidate._id]}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Box sx={{ p: 3, background: COLORS.background }}>
                              <Typography
                                sx={{
                                  fontSize: "16px",
                                  fontWeight: 700,
                                  color: COLORS.text,
                                  mb: 2,
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <FeedbackIcon sx={{ color: COLORS.accent }} />
                                Detailed Feedback
                              </Typography>

                              <Grid container spacing={3}>
                                {/* Technical Knowledge */}
                                <Grid item xs={12} sm={6} md={4}>
                                  <Box
                                    sx={{
                                      p: 2,
                                      background: COLORS.primary,
                                      borderRadius: "8px",
                                      border: `1px solid ${COLORS.border}`,
                                    }}
                                  >
                                    <Typography sx={{ fontSize: "13px", fontWeight: 700, color: COLORS.text, mb: 1 }}>
                                      Technical Knowledge
                                    </Typography>
                                    <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 ,border:COLORS.border}}>
                                      <Rating
                                        value={candidate.Technical_knowledge[0]?.rating || 0}
                                        readOnly
                                        size="small"
                                      />
                                      <Typography sx={{ fontSize: "12px", color: COLORS.textSecondary }}>
                                        {candidate.Technical_knowledge[0]?.rating || 0}/5
                                      </Typography>
                                    </Box>
                                    <Typography sx={{ fontSize: "12px", color: COLORS.text, lineHeight: 1.5 }}>
                                      {candidate.Technical_knowledge_detail}
                                    </Typography>
                                  </Box>
                                </Grid>

                                {/* Hands-on Skills */}
                                <Grid item xs={12} sm={6} md={4}>
                                  <Box
                                    sx={{
                                      p: 2,
                                      background: COLORS.primary,
                                      borderRadius: "8px",
                                      border: `1px solid ${COLORS.border}`,
                                    }}
                                  >
                                    <Typography sx={{ fontSize: "13px", fontWeight: 700, color: COLORS.text, mb: 1 }}>
                                      Hands-on Skills
                                    </Typography>
                                    <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
                                      <Rating
                                        value={candidate.Hands_on_skills[0]?.rating || 0}
                                        readOnly
                                        size="small"
                                      />
                                      <Typography sx={{ fontSize: "12px", color: COLORS.textSecondary }}>
                                        {candidate.Hands_on_skills[0]?.rating || 0}/5
                                      </Typography>
                                    </Box>
                                    <Typography sx={{ fontSize: "12px", color: COLORS.text, lineHeight: 1.5 }}>
                                      {candidate.Hands_on_skills_detail}
                                    </Typography>
                                  </Box>
                                </Grid>

                                {/* Problem Solving */}
                                <Grid item xs={12} sm={6} md={4}>
                                  <Box
                                    sx={{
                                      p: 2,
                                      background: COLORS.primary,
                                      borderRadius: "8px",
                                      border: `1px solid ${COLORS.border}`,
                                    }}
                                  >
                                    <Typography sx={{ fontSize: "13px", fontWeight: 700, color: COLORS.text, mb: 1 }}>
                                      Problem Solving
                                    </Typography>
                                    <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
                                      <Rating
                                        value={candidate.Problem_solving[0]?.rating || 0}
                                        readOnly
                                        size="small"
                                      />
                                      <Typography sx={{ fontSize: "12px", color: COLORS.textSecondary }}>
                                        {candidate.Problem_solving[0]?.rating || 0}/5
                                      </Typography>
                                    </Box>
                                    <Typography sx={{ fontSize: "12px", color: COLORS.text, lineHeight: 1.5 }}>
                                      {candidate.Problem_solving_detail}
                                    </Typography>
                                  </Box>
                                </Grid>

                                {/* Communication Skills */}
                                <Grid item xs={12} sm={6} md={4}>
                                  <Box
                                    sx={{
                                      p: 2,
                                      background: COLORS.primary,
                                      borderRadius: "8px",
                                      border: `1px solid ${COLORS.border}`,
                                    }}
                                  >
                                    <Typography sx={{ fontSize: "13px", fontWeight: 700, color: COLORS.text, mb: 1 }}>
                                      Communication Skills
                                    </Typography>
                                    <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
                                      <Rating
                                        value={candidate.Communication_skills[0]?.rating || 0}
                                        readOnly
                                        size="small"
                                      />
                                      <Typography sx={{ fontSize: "12px", color: COLORS.textSecondary }}>
                                        {candidate.Communication_skills[0]?.rating || 0}/5
                                      </Typography>
                                    </Box>
                                    <Typography sx={{ fontSize: "12px", color: COLORS.text, lineHeight: 1.5 }}>
                                      {candidate.Communication_skills_detail}
                                    </Typography>
                                  </Box>
                                </Grid>

                                {/* Culture Fit */}
                                <Grid item xs={12} sm={6} md={4}>
                                  <Box
                                    sx={{
                                      p: 2,
                                      background: COLORS.primary,
                                      borderRadius: "8px",
                                      border: `1px solid ${COLORS.border}`,
                                    }}
                                  >
                                    <Typography sx={{ fontSize: "13px", fontWeight: 700, color: COLORS.text, mb: 1 }}>
                                      Culture Fit
                                    </Typography>
                                    <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
                                      <Rating
                                        value={candidate.Culture_fit[0]?.rating || 0}
                                        readOnly
                                        size="small"
                                      />
                                      <Typography sx={{ fontSize: "12px", color: COLORS.textSecondary }}>
                                        {candidate.Culture_fit[0]?.rating || 0}/5
                                      </Typography>
                                    </Box>
                                    <Typography sx={{ fontSize: "12px", color: COLORS.text, lineHeight: 1.5 }}>
                                      {candidate.Culture_fit_detail}
                                    </Typography>
                                  </Box>
                                </Grid>

                                {/* Additional Comments */}
                                <Grid item xs={12}>
                                  <Box
                                    sx={{
                                      p: 2.5,
                                      background: COLORS.primary,
                                      borderRadius: "8px",
                                      border: `1px solid ${COLORS.border}`,
                                    }}
                                  >
                                    <Typography sx={{ fontSize: "13px", fontWeight: 700, color: COLORS.text, mb: 1.5 }}>
                                      Additional Comments
                                    </Typography>
                                    <Stack spacing={1.5}>
                                      <Box>
                                        <Typography sx={{ fontSize: "12px", fontWeight: 600, color: COLORS.text, mb: 0.5 }}>
                                          Next Round Recommendation:
                                        </Typography>
                                        <Typography sx={{ fontSize: "12px", color: COLORS.textSecondary }}>
                                          {candidate.next_round_recommendation || "—"}
                                        </Typography>
                                      </Box>
                                      <Divider sx={{ borderColor: COLORS.border }} />
                                      <Box>
                                        <Typography sx={{ fontSize: "12px", fontWeight: 600, color: COLORS.text, mb: 0.5 }}>
                                          Remarks:
                                        </Typography>
                                        <Typography sx={{ fontSize: "12px", color: COLORS.textSecondary }}>
                                          {candidate.remarks || "—"}
                                        </Typography>
                                      </Box>
                                    </Stack>
                                  </Box>
                                </Grid>
                              </Grid>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredCandidates.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              borderRadius: "0 0 10px 10px",
              background: COLORS.primary,
              borderTop: `1px solid ${COLORS.border}`,
              "& .MuiTablePagination-toolbar": {
                color: COLORS.text,
              },
              "& .MuiSelect-standard:before": {
                borderBottomColor: COLORS.border,
              },
              "& .MuiSelect-standard:after": {
                borderBottomColor: COLORS.accent,
              },
            }}
          />
        </>
      )}

      {/* Confirmation Dialog */}
      <Dialog
        open={confirmDialog.open}
        onClose={() =>
          setConfirmDialog({ open: false, roundId: null, decision: "", candidateName: "" })
        }
        PaperProps={{
          sx:{
            borderRadius: "10px",
            background: COLORS.background,
          },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: "18px",
            fontWeight: 700,
            color: COLORS.text,
            borderBottom: `1px solid ${COLORS.border}`,
          }}
        >
          Confirm Interviewer Decision
        </DialogTitle>

        <DialogContent sx={{ py: 3 }}>
          <Typography sx={{ fontSize: "14px", color: COLORS.text, mb: 2 }}>
            Are you sure you want to proceed with this decision?
          </Typography>

          {confirmDialog.candidateName && (
            <Box
              sx={{
                p: 2,
                background: COLORS.background,
                borderRadius: "8px",
                mb: 2,
                border: `1px solid ${COLORS.border}`,
              }}
            >
              <Typography sx={{ fontSize: "12px", color: COLORS.textSecondary, mb: 0.5 }}>
                Candidate:
              </Typography>
              <Typography sx={{ fontSize: "13px", fontWeight: 600, color: COLORS.text }}>
                {confirmDialog.candidateName}
              </Typography>
            </Box>
          )}

          <Box
            sx={{
              p: 2,
              background: COLORS.accent + "15",
              borderRadius: "8px",
              border: `1px solid ${COLORS.accent}40`,
            }}
          >
            <Typography sx={{ fontSize: "12px", color: COLORS.text, fontWeight: 600, mb: 0.5 }}>
              Decision:
            </Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 700, color: COLORS.accent }}>
              {confirmDialog.decision}
            </Typography>
          </Box>

          <Typography sx={{ fontSize: "12px", color: COLORS.textSecondary, mt: 2 }}>
            📧 An email will be sent to the candidate.
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{
            borderTop: `1px solid ${COLORS.border}`,
            padding: "12px 16px",
            gap: 1,
          }}
        >
          <Button
            onClick={() =>
              setConfirmDialog({ open: false, roundId: null, decision: "", candidateName: "" })
            }
            sx={{
              color: COLORS.text,
              border: `1px solid ${COLORS.border}`,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": {
                background: COLORS.background,
              },
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={() => {
              handleHRDecisionChange(
                confirmDialog.roundId,
                confirmDialog.decision
              );
              setConfirmDialog({ open: false, roundId: null, decision: "", candidateName: "" });
            }}
            sx={{
              background: COLORS.accent,
              color: "white",
              textTransform: "none",
              fontWeight: 600,
              "&:hover": {
                background: "#d63366",
              },
            }}
          >
            Confirm & Send
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default HRTable;